// Edit planner for engine-specific table options (v2 Slice E3).
//
// PRD: Ralph/DdlStructuralEdit2/PRD.md § Slice E3.
//
// Single op family — `alter-table-options`. Appends a fresh ALTER statement
// after the source statement (DSE2-7: no coalescing by default). The
// dialect synth may produce a multi-statement string (mssql REBUILD + SET,
// pgsql SET + RESET) joined with `;\n`; the planner emits a single
// PlannedByteEdit whose replacement contains the joined statements.

import { rangeFromOffsets } from '../../../sql-grammar/document/lineIndex';
import type { DdlEdit, PlannedByteEdit } from '../../types';

import { pickAppendInsertion } from './appendInsertion';
import type { DdlEditCtx } from './applyDdlEdit';
import { synthesizeAlterTableOptions } from './dialect.tableOptions';

type TableOptionsEdit = Extract<DdlEdit, { op: 'alter-table-options' }>;

export function planTableOptionsEdit(
  ctx: DdlEditCtx,
  edit: TableOptionsEdit,
): readonly PlannedByteEdit[] {
  const synth = synthesizeAlterTableOptions(ctx.engine, edit.table, edit.change);
  const { offset: insertAt, sep, trailSep } = pickAppendInsertion(
    ctx.source,
    ctx.statementInfo.range.endOffset,
  );
  return [{
    range: rangeFromOffsets(ctx.lineIdx, insertAt, insertAt),
    replacement: sep + synth + trailSep,
    rationale: edit.op,
  }];
}
